import React from "react";

export default function DSARPage() {

  return (
    <div className="row">
      <div className="col-12">
        <h1 className="cover-heading">Data Subject Access Request</h1>

        <p></p>

        <iframe src="https://app.termly.io/dsar/17afab85-64a4-411e-8248-3acc224f0214" width="100%" height="1300px"></iframe>
      </div>
    </div>
  )

}